// m-pill.component.ts
import { Component, Input } from '@angular/core';
import { PillType } from './m-pill.component.types';

@Component({
  selector: 'm-pill',
  templateUrl: './m-pill.component.html',
  styleUrls: ['./m-pill.component.scss']
})
export class MPillComponent {
  @Input() type: PillType = PillType.draft;
  @Input() text = '';
  @Input() showIcon = false;
  @Input() width: string | undefined;
  @Input() styleClass?: string;

  readonly iconMap: Record<PillType, string> = {
    [PillType.draft]: 'info',
    [PillType.info]: 'info',
    [PillType.done]: 'check_circle',
    [PillType.attention]: 'warning_amber',
    [PillType.error]: 'close'
  };
}
